export const version = "0.22.6";
